import { AxiosResponse } from 'axios';
import { apiInstallationApp } from './http';
import { ProductsExportResponse } from './interfaces/productsExport';

export function exportInstallationProducts(
  idi: number,
): Promise<AxiosResponse<ProductsExportResponse>> {
  return apiInstallationApp.get<ProductsExportResponse>(
    `${idi}/products/export`,
  );
}
